import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';
import { NFeEntradaAlterarTagsRequest } from '../../requests/repo-dfe/nfe-entrada-alterar-tags.request';

@Injectable({ providedIn: 'root' })
export class NFeEntradaTagService extends CommonService {
  private readonly apiUrl = environment.urlApiRepoDFe + 'NFeEntradaTag';

  constructor(private httpClient: HttpClient) { super(); }

  public alterarTags(request: NFeEntradaAlterarTagsRequest): Observable<ReturnStruct> {
    return this.httpClient.patch<ReturnStruct>(`${this.apiUrl}/bulk`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
